// localStorage that never throws. Some browsers throw on any access to
// window.localStorage (Firefox with cookies blocked for the site, some in-app
// browsers), and store.js reads it while the app boots - so one throw left a
// blank page. Here it falls back to an in-memory store: the site works, it just
// forgets these values on reload.
const memory = {}

function backend () {
  try {
    const ls = window.localStorage
    const probe = '__bb_storage_probe__'
    ls.setItem(probe, probe)
    ls.removeItem(probe)
    return ls
  } catch (e) {
    return null
  }
}

const ls = backend()

export default {
  getItem (key) {
    if (ls) {
      try {
        const value = ls.getItem(key)
        if (value !== null) {
          return value
        }
      } catch (e) {}
    }
    // Also where a write to real storage failed (quota full) and landed here.
    return Object.prototype.hasOwnProperty.call(memory, key) ? memory[key] : null
  },
  setItem (key, value) {
    if (ls) {
      try {
        ls.setItem(key, value)
        return
      } catch (e) {}
    }
    memory[key] = String(value)
  },
  removeItem (key) {
    if (ls) {
      try {
        ls.removeItem(key)
      } catch (e) {}
    }
    delete memory[key]
  }
}
